import {
  cardTitle,
  grayColor
} from "assets/jss/material-dashboard-pro-react.js";

import hoverCardStyle from "assets/jss/material-dashboard-pro-react/hoverCardStyle.js";

const cardStyle = {
  ...hoverCardStyle,
  cardTitle: {
    ...cardTitle,
    marginTop: "0px",
    marginBottom: "3px"
  },
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px"
  },
  cardProductTitle: {
    ...cardTitle,
    marginTop: "0px",
    marginBottom: "3px",
    textAlign: "center"
  },
  cardCategory: {
    color: grayColor[0],
    fontSize: "14px",
    paddingTop: "10px",
    marginBottom: "0",
    marginTop: "0",
    margin: "0"
  },
  cardClarify: {
    color: grayColor[0],
    fontSize: "14px",
    paddingTop: "0",
    marginBottom: "0",
    marginTop: "0",
    margin: "0"
  },
  cardRow: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: 10
  },
  stats: {
    color: grayColor[0],
    marginTop: 10,
    fontSize: "12px",
    lineHeight: "22px",
    display: "inline-flex",
    "& svg": {
      position: "relative",
      top: "4px",
      width: "16px",
      height: "16px",
      marginRight: "3px"
    },
    "& .fab,& .fas,& .far,& .fal,& .material-icons": {
      position: "relative",
      top: "4px",
      fontSize: "16px",
      marginRight: "3px"
    }
  },
  warningMsg: {
    color: "red",
    marginLeft: 10,
    marginBottom: 0
  }
};

export default cardStyle;
